
    <ion-list class="menu">
      <ion-item *ngIf="testStatus==='test_not_started'" (click)="dismissClick()" routerLink="/questionnaire/question" class="item-background-color">
        <ion-icon name="rocket-outline" slot="start" color="dark"></ion-icon>
        <ion-label>Check starten</ion-label>
      </ion-item>
      <ion-item *ngIf="testStatus==='test_started'" (click)="dismissClick()" routerLink="/questionnaire/question" class="item-background-color">
        <ion-icon name="rocket-outline" slot="start" color="dark"></ion-icon>
        <ion-label>weiter checken</ion-label>
      </ion-item>
      <ion-item *ngIf="testStatus==='test_finished'" (click)="dismissClick()" routerLink="/questionnaire/result" class="item-background-color">
        <ion-icon name="rocket-outline" slot="start" color="dark"></ion-icon>
        <ion-label>Ergebnis</ion-label>
      </ion-item>
      <ion-item class="menu-item" routerLink="/main/help" (click)="dismissClick()" class="item-background-color">
        <ion-icon name="bulb-outline" slot="start" color="dark"></ion-icon>
        <ion-label>Hilfe und Tipps</ion-label>
        </ion-item>
      <ion-item routerLink="/links" (click)="dismissClick()" class="item-background-color">
        <ion-icon name="globe-outline" slot="start" color="dark"></ion-icon>
        <ion-label>Nützliche Links</ion-label>
      </ion-item>
      <ion-item routerLink="/data-policy" (click)="dismissClick()" class="item-background-color">
        <ion-icon name="shield-half-outline" slot="start" color="dark"></ion-icon>
        <ion-label>Datenschutz</ion-label>
      </ion-item>
      <ion-item routerLink="/imprint" (click)="dismissClick()" class="item-background-color">
        <ion-icon src="assets/img/paragraph.svg" slot="start" color="dark"></ion-icon>
        <ion-label>Impressum</ion-label>
      </ion-item>
    </ion-list>

